<template>
    <div :class="['modal-overlay', `${brightness}`]">
        <div class="modal" :class="{ default: useModalDefaults }">
            <slot></slot>
        </div>
    </div>
</template>

<script lang="ts">
    export default {
        name: "ModalOverlay",
    };
</script>

<script setup lang="ts">
    withDefaults(
        defineProps<{
            useModalDefaults?: boolean;
            brightness?: "light" | "dark";
        }>(),
        {
            useModalDefaults: true,
            brightness: "light",
        }
    );
</script>

<style lang="scss">
    @import "@/style/variables";

    $light: rgba(0, 0, 0, 0.25);
    $dark: rgba(0, 0, 0, 0.6);

    .modal-overlay {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        align-items: center;
        z-index: 1030;

        &.light {
            background-color: $light;
        }

        &.dark {
            background-color: $dark;
        }

        .modal {
            display: grid;
            place-items: center;
            position: relative;
            margin-left: auto;
            margin-right: auto;
            height: 100%;
            width: 100%;

            &.default {
                box-shadow: $box-shadow-pop-up;
            }
        }
    }
</style>
